export function Pagination({ page, lastPage, total, onPageChange, label, ofLabel, previousLabel, nextLabel, dir = 'ltr' }) {
  if (!lastPage || lastPage <= 1) {
    return null;
  }

  const previousGlyph = dir === 'rtl' ? '›' : '‹';
  const nextGlyph = dir === 'rtl' ? '‹' : '›';

  return (
    <nav className="pagination" aria-label={label} dir={dir}>
      <button
        type="button"
        className="btn btn-ghost"
        disabled={page <= 1}
        onClick={() => onPageChange(page - 1)}
        aria-label={previousLabel || label}
      >
        {previousGlyph}
      </button>
      <span>
        {label} {page} {ofLabel} {lastPage}
        {typeof total === 'number' ? ` · ${total}` : ''}
      </span>
      <button
        type="button"
        className="btn btn-ghost"
        disabled={page >= lastPage}
        onClick={() => onPageChange(page + 1)}
        aria-label={nextLabel || label}
      >
        {nextGlyph}
      </button>
    </nav>
  );
}
